import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext';
import "./preview.css";
export const seo = {
    title: "Online Tools & Digital Services | Productivity, SEO & File Conversion",
    description:
        "Explore free and premium online tools including word counters, file converters, favicon generators, SEO analyzers, and text utilities. Improve productivity with powerful digital tools for students, writers, developers, and businesses.",
    keywords:
        "online tools, productivity tools, seo tools, text utilities, file converter, image to pdf, favicon generator, word counter, online utilities, digital tools, website tools",

};
export default function Preview() { 
    const { Toastshow } = Toast();
    const navigate = useNavigate();
      const [modemobile, setmodemobile] = useState(true);
    return (
        <div>
            {modemobile ? (
                <div className="mobile-preview-div ">
                <iframe  className="mobile-preview-iframe b-1 rounded" src="https://website-template.aooz.in/">
                </iframe>
                </div>
            ) : (
                   <div className="desktop-preview-div ">
                <iframe  className="desktop-preview b-1 rounded" src="https://website-template.aooz.in/"> </iframe>
              </div>
            )}
        <br/>
               
        </div>
    );
}
